<mat-card>
  <section fxLayout="row" fxLayoutGap="14">
    <ng-container *ngIf="dataSource && dataSource.length > 0; else noDataTemplate">
      <div fxFlex="25" fxLayout="column" fxLayoutAlign=" none">
        <!-- Search box -->
        <!-- <div class="search-div" [id]="tourId.workflows.wfrun.wfRunSearch.id">
          <mat-form-field class="search-box">
            <div>
              <span class="material-icons search-icon">search</span>
              <input type="text" placeholder="Search" aria-label="Search Workflow" matInput [(ngModel)]="searchValue"
                (input)="filterWfs(search.value)" #search>
              <span fxLayout="row" fxLayoutAlign=" center" (click)="searchClear()"><mat-icon
                  class="cursor">close</mat-icon></span>
            </div>
          </mat-form-field>
        </div> -->
        <!-- Mat cards -->
        <div #scrollContainer class="matCard item-list" (scroll)="onScroll($event.target)">
          <app-mat-card [data]="filteredData" [page]="'wfRun'" (cardClicked)="onCardClick($event)"
            (searchClear)="clear" [wfType]="wfType"></app-mat-card>
        </div>
      </div>
      <div fxFlex="75">
        <!-- Right panel mat-tabs -->
        <ng-container *ngIf="rowData; else noDataTemplate1">
          <mat-tab-group #tabGroup [id]="tourId.workflows.wfrun.wfExpanded.id"
            [(selectedIndex)]="tourGuideService.dashboardIndex">
            <ng-container *ngIf="!cf.statusArr.includes(rowData?.status.toLowerCase())">
              <mat-tab label="Run overview">
                <ng-template matTabContent>
                  <app-workflow-run-overview [rowData]="rowData" [stageDetails]="stgDtl"></app-workflow-run-overview>
                </ng-template>
              </mat-tab>
              <mat-tab label="Quality gates">
                <ng-template matTabContent>
                  <app-quality-gates-fe-wf [dataSource]="qgDataSource" [useDs]="true"></app-quality-gates-fe-wf>
                </ng-template>
              </mat-tab>
            </ng-container>
            <mat-tab label="Input and arguments">
              <ng-template matTabContent>
                <app-input-and-arguments [list]="inputArgumentList" [mode]="'read'"
                  [manualTriggerRes]="true"></app-input-and-arguments>
              </ng-template>
            </mat-tab>
          </mat-tab-group>
        </ng-container>
      </div>
    </ng-container>
    <ng-template #noDataTemplate>
      <app-no-data-available class="width100" fxLayout="row" fxLayoutAlign="center center" [newData]="noData"
        [page]="'wf-run'"></app-no-data-available>
    </ng-template>
    <ng-template #noDataTemplate1>
      <app-no-data-available [newData]="getNoData" [page]="'wf-run'"></app-no-data-available>
    </ng-template>
  </section>
</mat-card>